import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';

@Injectable()
export class DashboardClaimsService extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  getClaimsByRange(beginDate, endDate) {
    return this._http
      .get(`${constant.URL_GET_SUMARY_CLAIMS}${beginDate}/${endDate}`, this.getHeader())
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-claims/dashboard-claims.service.ts